<template>
    <div class="">
      <div class="bb-container bb-container--config">
        <no-ssr>
          <portal-target name="alerts_configuration"></portal-target>
        </no-ssr>
      </div>
  
      <div class="g-user-sidebar">
        <div class="bb-container bb-container--config">
          <div class="g-user-sidebar__grid">
            <left-menu active="my-piggybank" v-show="!isApp"></left-menu>
            <div class="g-user-sidebar__content">
              <h2 class="g-user-sidebar__head">{{ $t("settings.pbHowToReceiveMoney") }}</h2>
  
              <div class="g-user-sidebar__main g-user-sidebar__main--piggybank">
                <div class="config-data__form">
  
                  <!-- Bizum -->
                  <div class="bb-form-fieldset" v-if="user.locationCountry === 'ES'">
                    <label class="bb-form-checkbox">
                      <input type="checkbox" v-model="enabled.bizum" />
                      <span class="bb-form-checkbox__label">Bizum</span>
                    </label>
                    <div v-if="enabled.bizum">
                      <div class="bb-form-label">{{ $t("settings.pbBizumPhoneNumber") }}</div>
                      <input
                        v-model="form.bizum"
                        class="bb-form"
                        type="tel"
                        placeholder="Ej. 600123456"
                      />
                      <div class="bb-form-note">
                        {{ $t("settings.pbBizumMessage") }}
                      </div>
                    </div>
                  </div>
  
                  <!-- PayPal -->
                  <div class="bb-form-fieldset">
                    <label class="bb-form-checkbox">
                      <input type="checkbox" v-model="enabled.paypal" />
                      <span class="bb-form-checkbox__label">PayPal</span>
                    </label>
                    <div v-if="enabled.paypal">
                      <div class="bb-form-label">{{ $t("settings.pbPaypalUsername") }}</div>
                      <div class="bb-form-input-with-prefix">
                        <span class="prefix">paypal.me/</span>
                        <input
                          v-model="form.paypal"
                          class="bb-form"
                          type="text"
                          :placeholder="$t('settings.pbPaypalUsernamePH')"
                        />
                      </div>
                      <div class="bb-form-note">
                        {{ $t("settings.pbPaypalMessage") }}
                      </div>
                    </div>
                  </div>
  
                  <!-- Cuenta Bancaria -->
                  <div class="bb-form-fieldset">
                    <label class="bb-form-checkbox">
                      <input type="checkbox" v-model="enabled.iban" />
                      <span class="bb-form-checkbox__label">{{ $t("settings.pbTransfer") }}</span>
                    </label>
                    <div v-if="enabled.iban">
                      <div class="bb-form-label">{{ $t("settings.pbBankAccount") }}</div>
                      <input
                        v-model="form.iban"
                        class="bb-form"
                        type="text"
                        :placeholder="$t('settings.pbBankAccountPH')"
                      />
                      <div class="bb-form-note">
                        {{ $t("settings.pbBankAccountMessage") }}
                      </div>
                    </div>
                  </div>
  
                  <!-- Botón Guardar -->
                  <div class="bb-form-fieldset">
                    <button class="button button--primary button--block" @click.prevent="save">
                      {{ $t("generic.save") }}
                    </button>
                  </div>
  
                  <!-- Nota final -->
                  <div class="bb-form-note">
                    {{ $t("settings.pbFinalNote") }}
                  </div>
  
                </div>
              </div>
            </div>
          </div>
        </div>
        <alert v-show="false" />
      </div>
    </div>
  </template>
  
  <script>
import { mapGetters } from "vuex";
import LeftMenu from "./components/LeftMenu";
import ConfigurationAlert from "./components/ConfigurationAlert";
import NoSSR from "vue-no-ssr";

export default {
  name: "ConfigurationPaymentMethods",
  components: {
    LeftMenu,
    "no-ssr": NoSSR,
    alert: ConfigurationAlert,
  },
  data() {
    return {
      enabled: {
        bizum: false,
        paypal: false,
        iban: false,
      },
      form: {
        bizum: "",
        paypal: "",
        iban: "",
      },
      savedMethods: null, // para mostrar por pantalla si quieres
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
      isApp: "isApp",
    }),
    alertKey(){
      return "payment_methods_config"
    },
    showAlertLocal() {
      return this.showAlertKey === this.alertKey && this.showAlert;
    }
  },
  methods: {
    save() {
      const methods = [];

      if (this.enabled.bizum) {
        const phone = this.form.bizum.trim();
        if (!phone) {
          this.$alert.error(this.$t("settings.pbBizumEmptyNumber"));
          return;
        }
        methods.push({
          methodSlug: "bizum",
          data: phone
        });
      }

      if (this.enabled.paypal) {
        const username = this.form.paypal.trim();
        if (!username) {
          this.$alert.error(this.$t("settings.pbPaypalEmptyUsername"));
          return;
        }
        methods.push({
          methodSlug: "paypal",
          data: `https://paypal.me/${username}`
        });
      }

      if (this.enabled.iban) {
        const iban = this.form.iban.trim();
        if (!iban) {
          this.$alert.error(this.$t("settings.pbBankAccountEmpty"));
          return;
        }
        methods.push({
          methodSlug: "bank_transfer",
          data: iban
        });
      }

      try {
        this.$store.dispatch("updateUserContributionMethods", methods);
        this.savedMethods = methods;
        
        if (this.$route.query.backTo === "hucha" && methods.length > 0) {
          this.$alert.success(this.$t("settings.pbSavedBackTo"), this.alertKey);
          setTimeout(() => {
            //add query param 'from' settings
            this.$router.push({ name: "contributions", query: { from: "settings" } });
          }, 3000);
        }
        else if (this.$route.query.backTo === "hucha" && methods.length === 0) {
          setTimeout(() => {
            this.$router.push({ name: "hucha-crear" });
          }, 500);
        }
        else {
          this.$alert.success(this.$t("settings.pbSaved"), this.alertKey);
        }
      } catch (error) {
        console.error("Error al guardar métodos de pago", error);
        this.$alert.error(this.$t("settings.pbGenericError"));
      }
    },
    loadUserPaymentMethods() {
      if (!this.user || !this.user.contributionMethods) return;

      for (const method of this.user.contributionMethods) {
        const slug = method.method.slug;
        const data = method.data?.trim();

        if (slug === "bizum" && data) {
          this.enabled.bizum = true;
          this.form.bizum = data;
        }

        if (slug === "paypal" && data) {
          this.enabled.paypal = true;
          // extraemos solo el nombre de usuario de la URL (si viene completa)
          this.form.paypal = data.replace(/^.*paypal\.me\//, "");
        }

        if (slug === "bank_transfer" && data) {
          this.enabled.iban = true;
          this.form.iban = data;
        }
      }
    },
  },
  mounted() {
    this.loadUserPaymentMethods();
  },
};
</script>
  
  <style scoped>
  .bb-form-input-with-prefix {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .bb-form-input-with-prefix .prefix {
    font-size: 14px;
    color: #888;
  }
  .bb-form-note {
    font-size: 13px;
    color: #666;
    margin-top: 4px;
  }
  .bb-form-checkbox {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .bb-form-checkbox__label {
    margin-left: 8px;
    font-weight: 600;
  }
  </style>
  
  
  
  